<template>
    <div class="bill_list_container" v-infinite-scroll="loadMore" infinite-scroll-disabled='loading' infinite-scroll-distance='10'>
        <div class="bill_card" v-for='(item, index) in orderData' :key="index">
            <div class="bill_header">
                <span class="bill_cate">{{ item.cate }}</span>
                <span class="bill_time">{{ item.created_at }}</span>
            </div>
            <div class="bill_body">
                <div class="info_row">
                    <span class="info_label">加油详情</span>
                    <span class="info_value amount">{{ item.change }}升</span>
                </div>
                <div class="info_row">
                    <span class="info_label">车牌号</span>
                    <span class="info_value">{{ item.car_number }}</span>
                </div>
                <div class="info_row">
                    <span class="info_label">司机</span>
                    <span class="info_value">{{ item.driver_name }}</span>
                </div>
            </div>
        </div>
        
        <!--显示加载中-->
        <div class="loading-box" v-if="isloading">
            <mt-spinner type="snake"></mt-spinner>
            <span class="loading-more-txt">加载中...</span>
        </div>
        <!-- 显示没有更多 -->
        <div class="no-more" v-show="noMone">已经到底啦</div>
        <tabbar :selected="selected"></tabbar>
    </div>
</template>

<script>
    import common from "../common";
    import {InfiniteScroll, Spinner} from 'mint-ui';
    import Vue from "vue";
    import tabbar from '@/components/tabbar'

    Vue.use(InfiniteScroll);
    Vue.component(Spinner.name, Spinner);
    export default {
        name: 'billList',
        components: {tabbar},
        data() {
            return {
                msg: '分油记录',
                orderData: [],
                pageVal: "0",
                pageSize: "10",
                loading: false, //为true时不会触发加载更多，false可以触发
                isloading: false,//显示加载中
                noMone: false,//是否没有更多
                token: ""
            }
        },
        methods: {
            //获取列表
            getList() {
                let token = this.token;
                let querystring = require('querystring');
                this.$api.post('wx/billList',
                    querystring.stringify({
                        pageSize: this.pageSize,
                        pageNum: this.pageVal,
                        token: token
                    })
                ).then(data => {
                    if (this.pageVal < data.data.pageTotal) {
                        for (var i = 0; i < data.data.pageSize; i++) {
                            this.orderData.push(data.data.data[i]);
                        }
                        this.loading = false;
                    } else if (this.pageVal == data.data.pageTotal) {
                        for (var i = 0; i < data.data.data.length; i++) {
                            this.orderData.push(data.data.data[i]);
                        }
                        this.loading = false;
                    } else {
                        this.loading = true;
                        this.noMone = true;
                    }
                    this.isloading = false;
                }).catch(err => {
                    console.log(err);
                })
            },
            //分页加载更多
            loadMore() {
                this.loading = true;
                this.isloading = true;
                this.pageVal++;
                this.getList();
            },
        },
        mounted() {
            //判断cookie中是否存在token
            let ifcookietoken = document.cookie.indexOf("token=") != -1;
            if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
                this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
            } else if (ifcookietoken) {
                this.token = common.getCookie("token");
            } else {
                this.$router.replace({name: 'login'});
            }
        },
        beforeDestroy() {

        },
    }
</script>

<style scoped>
    .bill_list_container {
        width: 100vw;
        height: 100vh;
        background: #f6f8fa;
        overflow-y: auto;
        padding: 16px;
        box-sizing: border-box;
        padding-bottom: 80px;
    }

    .bill_card {
        background: white;
        border-radius: 16px;
        padding: 20px;
        margin-bottom: 16px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .bill_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        border-bottom: 1px solid #f1f3f5;
    }

    .bill_cate {
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }

    .bill_time {
        font-size: 13px;
        color: #adb5bd;
    }

    .bill_body {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .info_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
    }

    .info_label {
        color: #adb5bd;
    }

    .info_value {
        color: #495057;
        font-weight: 600;
    }

    .info_value.amount {
        color: #e03131;
        font-size: 18px;
        font-weight: 700;
    }

    .loading-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        color: #adb5bd;
        font-size: 14px;
        gap: 10px;
    }

    .no-more {
        text-align: center;
        color: #adb5bd;
        font-size: 14px;
        padding: 40px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/billList.vue